module.exports = __webpack_public_path__ + "static/media/twitter-white.6c7e6bef.svg";